import { Suspense, LazyExoticComponent, ComponentType, forwardRef, SuspenseProps } from 'react';

export const suspend = <P, T extends ComponentType<P>>(
    LazyComponent: LazyExoticComponent<T>,
    fallback: SuspenseProps['fallback'] = null
) => forwardRef<T, P>((props, ref) => (
    <Suspense fallback={fallback}>
        <LazyComponent {...props as any} ref={ref} />
    </Suspense>
));
